<template>
  <vx-card class="mb-4" title="MY TASTE PANELS">
    <div>
      <div class="vx-row">
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
          <label class="text-sm opacity-100 text-bold">Search</label>
          <vs-input type="text" class="w-full" v-model="filters['search']" />
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
          <label class="text-sm opacity-100 text-bold">From</label>
          <flat-pickr
            class="w-full"
            :config="{ dateFormat: 'd/m/Y' }"
            v-model="filters['from']"
            placeholder="Choose Date"
          />
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
          <label class="text-sm opacity-100 text-bold">To</label>
          <flat-pickr
            class="w-full"
            :config="{ dateFormat: 'd/m/Y' }"
            v-model="filters['to']"
            placeholder="Choose Date"
          />
        </div>
        <div class="vx-col md:w-1/5 sm:w-1/2 w-full mb-5">
          <label class="text-sm opacity-100 text-bold">Status</label>
          <v-select
            :clearable="true"
            v-model="filters['status']"
            :options="['Pending', 'Completed']"
            label="status "
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
          ></v-select>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full md:w-6/6">
          <vs-button
            class="float-right mr-4 mb-2"
            size="small"
            color="danger"
            type="border"
            icon-pack="feather"
            v-on:click="filters = {}"
            >CLEAR</vs-button
          >
        </div>
      </div>
    </div>
    <div>
      <vs-table
        stripe
        :data="tasteGroupList"
        :sst="true"
        class="table-auto vs-con-loading__container"
        id="mass-balance-audit-table"
      >
        <template slot="thead">
          <vs-th>TASTE PANEL CODE</vs-th>
          <vs-th>TASTE PANEL CREATED BY</vs-th>
          <vs-th>TASTE PANEL CREATED AT</vs-th>
          <vs-th>STATUS</vs-th>
          <vs-th>RM BATCH CODES</vs-th>
          <vs-th>WO CODES</vs-th>
          <vs-th>ACTION</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="(tr, indextr) in data" :key="indextr">
            <vs-td>
              <span
                class="text-primary"
                style="cursor: pointer"
                @click="goToTastePanel(tr.id)"
              >
                {{ tr.code }}
              </span>
            </vs-td>
            <vs-td>
              {{ tr.created_by.name }}
            </vs-td>
            <vs-td>
              {{ __dateTimeFormatterToDate(tr.created_at) }}
            </vs-td>
            <vs-td>
              {{ getStatus(tr) }}
            </vs-td>
            <vs-td>
              <template
                v-for="(inventory, index) in tr.raw_material_stock_inventories"
              >
                <HyperLink
                  :id="inventory.staff_raw_material_order_item.raw_material.id"
                  :supplier_id="inventory.staff_raw_material_order_item.raw_material.supplier_id"
                  type="raw-material"
                >
                  {{ inventory.code }}
                  -
                  {{ inventory.staff_raw_material_order_item.raw_material.company_product_name }}
                </HyperLink>

                <span v-if="index < tr.raw_material_stock_inventories.length - 1">
                  ,
                </span>
              </template>
            </vs-td>
            <vs-td>
              <template v-for="(workOrder, index) in tr.work_orders">
                <HyperLink
                  :id="workOrder.id"
                  type="work-order"
                >
                  {{ workOrder.work_order_code }}
                </HyperLink>

                <span v-if="index < tr.work_orders.length - 1">, </span>
              </template>
            </vs-td>
            <vs-td>
              <div class="vx-row">
                <vx-tooltip
                  class="text-primary cursor-pointer mr-2"
                  text="View/Update"
                  position="top"
                >
                  <vs-button
                    @click.stop="onCLickViewTestPanel(tr.id)"
                    size="small"
                    icon-pack="feather"
                    icon="icon-eye"
                  ></vs-button>
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <UserTastePanel ref="userTastePanel" />
    <vs-pagination
      v-on:changeMaxItems="changePage"
      :size-array="meta.total ? meta.total : 20"
      :max-items="perPage"
      description-body="Rows per page"
      description-connector="of"
      description-title="Records"
      description
      :description-items="descriptionItems"
      :total="meta.last_page ? meta.last_page : 0"
      v-model="page"
      class="p-5"
    >
    </vs-pagination>
  </vx-card>
</template>
<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import UserTastePanel from "@/components/popups/TastePanel/UserTastePanel";
import { defaultPagination, perPageList } from "@/constants/config";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import Filter from "@/mixins/filter";
const TriangleTestsRepository = RepositoryFactory.get("triangle_tests");
export default {
  name: "MyTastePanels",
  components: {
    UserTastePanel,
    flatPickr,
    "v-select": vSelect,
  },
  async mounted() {
    await this.getMyTastePanels();
  },
  data() {
    return {
      tasteGroupList: [],
      filters: {},
      meta: {},
      maxItems: 20,
      page: 1,
      total: 0,
      sort: "",
      perPage: defaultPagination,
      descriptionItems: perPageList,
    };
  },
  mixins: [Filter],
  methods: {
    async getMyTastePanels() {
      try {
        this.$vs.loading();
        const response =
          await TriangleTestsRepository.getTastingGroupsAssignedToUser(
            this.filterQuery,
            this.page,
            this.perPage
          );

        this.tasteGroupList = response.data.data;
        this.meta = response.data.meta;
      } catch (error) {
      } finally {
        this.$vs.loading.close();
      }
    },
    getBatchCodes(rawMaterialStockInventories) {
      return rawMaterialStockInventories
        .map((item) => {
          return `${item.code} - ${item.staff_raw_material_order_item.raw_material.company_product_name}`;
        })
        .join(",");
    },
    getWoCodes(workOrders) {
      return workOrders
        .map((item) => {
          return item.work_order_code;
        })
        .join(", ");
    },
    getStatus(item) {
      return item.staff[0] ? item.staff[0].pivot.status : "Pending";
    },
    filterQueryUpdate() {
      this.getMyTastePanels();
    },
    handleChangePage(page) {
      this.page = page;
      this.getMyTastePanels();
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index];
    },
    goToTastePanel(id) {
      const route = this.$router.resolve({
        path: `/pages/taste-Panels?open=${id}`,
      });
      window.open(route.href, "_blank");
    },
    onCLickViewTestPanel(id) {
      this.$refs.userTastePanel.openPopup(id);
    },
  },
  watch: {
    page() {
      this.getMyTastePanels();
    },
    perPage() {
      this.getMyTastePanels();
    },
  },
};
</script>
